export const IMMERSION = 'immersion'
